import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useHistory } from 'react-router';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { useCallCenterContext } from '~/mobx/ordersStore/context';
import { OrderTabs } from '~/mobx/ordersStore/types';
import { LoadingStatus } from '~/types/main';

type TProps = {};

const CreateOrderButton: React.FC<TProps> = (): JSX.Element => {
  const { store: callCenterStore } = useCallCenterContext();
  const history = useHistory();

  const createDraft = useCallback(() => {
    const createDraftAsync = async () => {
      const orderId = await callCenterStore.createDraft();

      if (orderId !== null) {
        history.push(SCREENS.CALLCENTER_ORDER_EDIT(orderId));
        callCenterStore.setActiveTab(OrderTabs.Draft);
      }
    };

    createDraftAsync();
  }, []);

  return (
    <Button
      title={localeStore.t('create_order')}
      onClick={createDraft}
      disabled={callCenterStore.draftLoadingStatus === LoadingStatus.Loading}
      loading={callCenterStore.draftLoadingStatus === LoadingStatus.Loading}
      appearance="secondary"
    />
  );
};

export default observer(CreateOrderButton);
